import React from 'react';
import { Link } from 'react-router-dom';
import StarFill from '../icons/StarFill';
import { Group, Person } from '../icons';
import './scss/BoardGridItem.scss';
import BoardVisibilityIcon from '../Global/BoardVisibilityIcon';
import useHandlePopoverClick from '../../hooks/useHandlePopoverClick';

const BoardGridItem = ({ board, workspace, isGuests, isUserLoaded, user, toggleStar, handleMoreClick }) => {
    const { handlePopoverClick } = useHandlePopoverClick();
    const members = (board.members || []).filter(member => member._id);
    const cardsCount = board.cardsCount || 0;
    const wCardsCount = workspace?.cardsCount || 0;
    const coverColor =
        Array.isArray(board?.cover?.coverColor) && board.cover.coverColor.length > 2
            ? board.cover.coverColor[2]
            : null;

    const isStarred = user?.user?.starredBoards?.includes(board._id);

    // Function to add transparency to RGB colors
    const addTransparency = (rgbColor, alpha = 1) => {
        if (!rgbColor) return 'transparent';
        const match = rgbColor.match(/\d+/g);
        if (!match || match.length < 3) {
            return rgbColor;
        }
        const [r, g, b] = match;
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const handleToggleStar = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleStar(board._id, board.shortId);
    };

    return (
        <div className="board-grid-item-card">
            <Link to={board.permalink} className="board-grid-item-link">
                {/* 45% Cover section */}
                <div className="card-cover">
                    {board?.cover?.url || board?.cover?.sizes?.medium ? (
                        <img
                            src={board?.cover?.sizes?.medium || board?.cover?.url}
                            alt={board.title}
                            className="cover-img"
                            loading="lazy"
                        />
                    ) : (
                        <div
                            className="cover-placeholder"
                            style={coverColor ? { background: coverColor } : {}}
                        />
                    )}

                    {/* Actions overlay moved inside cover area to match Page UI feel */}
                     <div className="card-actions-overlay">
                        <button
                            className={`card-actions-btn star-btn ${isStarred ? 'starred' : ''}`}
                            onClick={handleToggleStar}
                            title={isStarred ? 'Remove from favorites' : 'Add to favorites'}
                        >
                            {isUserLoaded && (
                                <>
                                    {!isStarred ? (
                                        <span className="material-symbols-outlined">kid_star</span>
                                    ) : (
                                        <StarFill color="#FFD700" size={16} />
                                    )}
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {/* Content section */}
                <div className="card-content">
                    {/* Overlapping icon */}
                    <div className="card-icon">
                        <BoardVisibilityIcon visibility={board.visibility} size={16} isReadOnly={isGuests} />
                    </div>

                    <h3 className="card-title">{board.title}</h3>

                    <div className="card-footer">
                        <div className="footer-left">
                            <span className="stats-text" data-tooltip-content="Cards" data-tooltip-position="bottom">
                                {!isGuests ? `${cardsCount} / ${wCardsCount}` : cardsCount}
                            </span>
                        </div>

                        <div className="footer-right">
                            {members.length > 0 && (
                                <div 
                                    className="members-info-trigger"
                                    id={`popover-more-members-${board.shortId}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handlePopoverClick(e, 'moreMembers', { boardId: board.shortId, isBack: true, backPopover: 'moreMembers' });

                                        
                                    }}
                                    data-popover-trigger
                                    data-tooltip-content="Members"
                                    data-tooltip-position="top"
                                >
                                    <Person size={18} color="var(--secondary-text-color)" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default BoardGridItem;
